module.exports = __webpack_public_path__ + "img/depmap_svg_V38.a60311b5.svg";